import { Flex, RemoteImage } from '@banhala/ui-kit';
import { StyleSheet, View } from 'react-native';

const PROFILE_SIZE = 56;
const PROFILE_INNER_SIZE = 50;

type Props = {
  uri: string;
  /** 무물라이브 상태 링 색상. null 이면 링 없이 기본 프로필. */
  ringColor: string | null;
  /** 프로필 클릭. 상태별 액션은 상위에서 주입한다. */
  onPress?: () => void;
};

/**
 * 마켓 프로필 이미지.
 * 56 컨테이너 안에 50 이미지를 중앙 배치(Figma 기준). `ringColor` 가 있으면
 * 1.5px 상태 링을 그린다. (DEFAULT 는 링 없이 동일한 인셋만 유지)
 */
export const MarketProfileImage = ({ uri, ringColor, onPress }: Props) => {
  return (
    <Flex onPress={onPress}>
      <View
        style={[
          styles.container,
          { borderColor: ringColor ?? 'transparent' },
        ]}
      >
        <Flex
          width={PROFILE_INNER_SIZE}
          height={PROFILE_INNER_SIZE}
          borderRadius={PROFILE_INNER_SIZE / 2}
          overflow={'hidden'}
        >
          <RemoteImage
            width={PROFILE_INNER_SIZE}
            height={PROFILE_INNER_SIZE}
            uri={uri}
          />
        </Flex>
      </View>
    </Flex>
  );
};

const styles = StyleSheet.create({
  container: {
    width: PROFILE_SIZE,
    height: PROFILE_SIZE,
    borderRadius: PROFILE_SIZE / 2,
    // borderWidth 를 상수로 항상 두고 borderColor 만 동적으로 변경한다.
    // (Android 첫 렌더에서 borderRadius 가 border 에 적용 안 되는 이슈 회피)
    borderWidth: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
